export const STC_V1 = 'application/vnd.pwpw.infocar.stc.public.v1+json';
export const STC_V2 = 'application/vnd.pwpw.infocar.stc.public.v2+json';
export const DEALS_V1 = 'application/vnd.pwpw.infocar.deals.public.v1+json';
export const ACCOUNTS_V1 = 'application/vnd.pwpw.infocar.accounts.public.v1+json';
export const ACCOUNTS_V2 = 'application/vnd.pwpw.infocar.accounts.public.v2+json';
